import KitLog from "./KitLog";
import {KitTimer} from "./KitTimer";
import {KitSp} from "./KitSp";
import {GameLifecycle} from "@/Fwk/Kit/GameLifecycle";
import {NetworkMonitor} from "@/Fwk/Kit/NetworkMonitor";
// import {Action} from "@/Fwk/Kit/KitConst";

/// <author>xiexingwu</author>
export class KitBehaviour {
    static _timer = new KitTimer();

    public static Init() {
        if (KitLog.IsLog) KitLog.Log("KitBehaviour Init");

        GameLifecycle.GameCreated();
        GameLifecycle.GameResumed();
        this._timer.SetTimer("kit", () => {
            this.onSencond();
        }, -1, 1000);
        document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    }


    static onSencond() {
        NetworkMonitor.checkNetworkStatus();
        KitSp.Save();
    }

    private static handleVisibilityChange() {
        const isVisible = document.visibilityState === 'visible';
        if (isVisible)
            GameLifecycle.GameResumed();
        else
            GameLifecycle.GamePaused();

    }
}